import React from 'react';
import loadable from '@loadable/component';
import { Loading } from 'components';
import { ROUTES_PATH_RESET_PASSWORD } from 'routes';

const ResetPassword = loadable(() => import('./components'), {
	fallback: <Loading size={50} />,
});

export const ResetPasswordRoutes = [
	{
		path: ROUTES_PATH_RESET_PASSWORD,
		component: ResetPassword,
		isPublic: true,
	},
];

export default ResetPasswordRoutes;
